// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1ps3X","row":"Node_row__-cx9F","label":"Node_label__17zOZ","footer":"Node_footer__3PQ6I"};